export default "__VITE_ASSET__CCTT9kun__"